import React, { useState } from "react";
import background from "../Assets/Background/bg1.webp";
import logo from "../Assets/Logo/logo.png";
import leaveicon from "../Assets/Icon/leaveicon.svg";
import Guesticon from "../Assets/Icon/guesthouseicon.svg";
import asseticon from "../Assets/Icon/asseticon.svg";
import ComingSoon from "../Assets/Images/coming-soon-img.webp"
import Workorder from "../Assets/Icon/workorder.svg"
import { Link } from "react-router-dom";
import CustomModal from "./CustomModal";

const Home = () => {
  const [masterModel, setMasterModel] = useState(false);

  return (
    <>
      <section className="container-fluid px-0">
        <div className="homebox1">
          <div className="centeredicon">
            <img src={logo} alt="NITTTR Logo" className="homelogo" />
          </div>
        </div>
      </section>
      <section>
        <div className="container-fluid px-0">
          <div className="homebg">
            <img src={background} alt="NITTTR" className="backgroundsize" />
            <div className="centered">
              <h1 className="hometext">Enterprise Resource Planning System</h1>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container-fluid">
          <div className="homebox">
            <div className="homecontainerbottom">
              <div className="row">
                <div className="col-lg-3 col-md-3 col-sm-12 col-12">
                  <div className="circlecenter">
                    <div className="homecircle">
                      <Link to="/Login">
                        <div className="innercircle">
                          <img
                            src={leaveicon}
                            alt="Leave Management"
                            className="homeicon"
                          />
                        </div>
                      </Link>
                    </div>
                    <h6 className="circletitle">
                      Leave Management & Appraisal Report
                    </h6>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-12 col-12">
                  <div
                    className="circlecenter"
                    onClick={() => setMasterModel(true)}
                  >
                    <div className="homecircle">
                      {/* <Link to="/Comingsoon"> */}
                      <div className="innercircle">
                        <img
                          src={Guesticon}
                          alt="Guest House Management"
                          className="homeicon"
                        />
                      </div>
                      {/* </Link> */}
                    </div>
                    <h6 className="circletitle">Guest House Management</h6>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-12 col-12">
                  <div className="circlecenter">
                    <div className="homecircle">
                      {/* <Link to="/Login"> */}

<a href="https://nitttrc.edu.in/stores/login.php" target="_blank">
                        <div className="innercircle">
                          <img
                            src={asseticon}
                            alt="Asset Management"
                            className="homeicon"
                          />
                        </div>
                      </a>
                    </div>
                    <h6 className="circletitle">Asset Management</h6>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-12 col-12">
                  <div className="circlecenter">
                    <div className="homecircle">
                      {/* <a href="http://192.168.12.17:3000/wof/login" target="_blank">
                        <div className="innercircle">
                          <img
                            src={Workorder}
                            alt="Asset Management"
                            className="homeicon"
                          />
                        </div>
                      </a> */}
                      <a href="https://nitttrc.edu.in/workorder/" target="_blank">
                        <div className="innercircle">
                          <img
                            src={Workorder}
                            alt="Asset Management"
                            className="homeicon"
                          />
                        </div>
                      </a>
                    </div>
                    <h6 className="circletitle">Work Order</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* masterModel */}
      <CustomModal
        open={masterModel}
        onClickOutside={() => {
          setMasterModel(false);
        }}
      >
        <div className="modal-content Modal-View m-auto">
          <div className="modal-body p-0 ">
            <div className="close-icon-modal" onClick={() => {
              setMasterModel(false);
            }}>
              <span class="material-symbols-outlined close-icon-home-modal">
                close
              </span>
            </div>
            <div className="container">
              <div className="comingsoon mb-5">
                {/* <h4>COMING SOON</h4> */}
                <img className="coming-soon-img" src={ComingSoon} alt="" />
              </div>
            </div>
          </div>
          {/* <div className="modal-footer border-0">
            <div>
              <button
                type="button"
                className="btn mx-2 submit-btn"
                onClick={() => {
                  setMasterModel(false);
                }}
              >
                Close
              </button>
            </div>
          </div> */}
        </div>
      </CustomModal>
    </>
  );
};

export default Home;
